import {
  productMetafieldKnowledgeDraftSchema,
  productMetafieldKnowledgeSchema,
} from "@redotech/shopper-agent-knowledge-common/product-metafield-view";
import * as z from "zod";

/**
 * Replaces the account's configured metafields with exactly this set, in one
 * transaction. An empty set turns metafield knowledge off.
 */
export const saveProductMetafieldKnowledge = {
  name: "saveProductMetafieldKnowledge" as const,
  input: z
    .object({ entries: z.array(productMetafieldKnowledgeDraftSchema) })
    .strict(),
  output: z.object({ entries: z.array(productMetafieldKnowledgeSchema) }),
};
